import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AudioFileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"audio_file"}/>
}
